module.exports = __webpack_public_path__ + "img/en.7615ffb3.svg";